import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextSignalRenin = () => {

return(
<div>
    
<Typography variant="h6" >

The variant rs5186 on gene AGTR1 with A/C genotype implies a 1.4x increased risk of hypertension (SNPedia).
Located in the 3' untranslated region of the angiotensin II receptor type 1 gene AGTR1, among the most studied of over 50 SNPs in AGTR1.  <br /><br />


Pregnant women who are rs5186(C) allele carriers are more likely to develop pregnancy-induced hypertension.<br /><br />

Variant rs5186 (AGTR1) together with rs2228570 (VDR - Vitamin D Receptor gene) is associated with BP elevation in hypertensive patients. BP values do not depend on VDR gene (rs2228570) polymorphic variants.   
(Source:  https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8811662/) <br /><br />


Variant rs1042713 (ADRB2):  This is a well studied variant in the beta 2 adrenergic receptor (see the ADRB2 VIP summary) also known as Arg16Gly, where rs1042713A is Arg and rs1042713G is Gly.<br /><br />
ADRB2 encodes the beta-2-adrenergic receptor (beta2-AR), a G-protein-coupled adrenergic receptor that plays important roles in the regulation of the cardiac, pulmonary, vascular, endocrine and central nervous systems. 
Beta2-AR is the target of clinically important drugs for asthma and cardiovascular conditions including hypertension and congestive heart failure. (Source: pharmgkb) <br /><br />

Variant rs1799983 (NOS3): normal risk with genotype G/G, pregnancy-induced hypertension. (Source: SNPedia)
<br /><br />
</Typography>

</div>
)
}